export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS'
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS'
export const ADD_PROJECT_SUCCESS = 'ADD_PROJECT_SUCCESS'
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS'
export const SET_FETCHING_PROJECTS = 'SET_FETCHING_PROJECTS'
